module.exports = __webpack_public_path__ + "static/media/it2.c3ec00fb.png";